import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { views } from "../../Configs/config";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.75)}`}; // 0.5rem
  width: ${(props) => (props?.view === views.MAP ? "65%" : "100%")};
  height: 100%;
  padding: ${() =>
    `${viewSizeCalculator(0.75)} ${viewSizeCalculator(
      0.75,
    )} ${viewSizeCalculator(0.75)} ${viewSizeCalculator(1.5)}`};

  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  background-color: #fff;
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  transition: width 400ms ease-in-out;
`;

export const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
  transition: height 300ms ease-in-out, min-height 300ms ease-in-out;
  ${({ view }) =>
    view === views.MAP
      ? `height: ${viewSizeCalculator(4.75)};`
      : `min-height: ${viewSizeCalculator(3)};`}
`;

export const TopSectionContent = styled.div`
  padding-top: ${() => `${viewSizeCalculator(4, true)}`};
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  ${({ view }) => (view === views.MAP ? "height: 100%;" : "")}
`;

export const TitleContainer = styled.div`
  /* width: ${() => `${viewSizeCalculator(8.875)}`}; */
  display: flex;
  align-items: baseline;
  gap: ${() => `${viewSizeCalculator(0.325)}`}; // 0.625rem
  letter-spacing: ${() => `${viewSizeCalculator(0.0625)}`};
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
`;

export const Reset = styled.div`
  font-family: Inter;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  line-height: ${() => `${viewSizeCalculator(0.9831)}`}; // 0.8125rem
  letter-spacing: 0%;

  cursor: pointer;
  color: #007bff;
  padding: 0 ${() => `${viewSizeCalculator(1)}`};
  border-radius: 10px;
  padding: 8px 12px;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem
`;

export const Count = styled.p`
  font-size: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(1.5125)}`};
  color: ${({ isGray }) => (isGray ? "#a0a0a0" : "inherit")};
`;

export const Title = styled.span`
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: 600;
  line-height: ${() => `${viewSizeCalculator(1.21)}`};
  // text-transform: capitalize;
`;

export const TitleBlock = styled(Title)`
  font-size: ${({ fontSize }) => (fontSize ? viewSizeCalculator(fontSize, true) : viewSizeCalculator(1))}; // 1.8rem
  line-height: ${() => `${viewSizeCalculator(1.35)}`};
  display: block;
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : "600")};
`;

export const FilterBox = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
  border: ${() => `${viewSizeCalculator(0.125)} solid #ebebeb`}; // 0.125rem
  background-color: #ffffff;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;

export const MainContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  min-height: 0;
`;

export const GraphSection = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const Slider = styled.div`
  width: ${() => `${viewSizeCalculator(6)}`}; // 6rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;
  border: ${() => `${viewSizeCalculator(2, true)} solid #ebebeb`};
  background-color: #f5f5f5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const SliderContentFirst = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  z-index: 2;
  svg {
    width: ${() => `${viewSizeCalculator(1)}`}; // 1rem
    height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  }
`;

export const SliderContentSecond = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  z-index: 2;

  svg {
    width: ${() => `${viewSizeCalculator(1.0206)}`}; // 3rem
    height: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  }
`;

export const SliderHoverContainer = styled.div`
  width: ${() => `${viewSizeCalculator(3)}`}; // 3rem
  height: ${() => `${viewSizeCalculator(3)}`}; // 3rem

  border: ${() => `${viewSizeCalculator(2, true)} solid #ebebeb`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem;

  background-color: #ffffff;

  position: absolute;

  z-index: 1;

  left: ${({ view }) => (view === views.MAP ? "50%" : "-2%")};

  transition: all 300ms ease-in-out;
`;

export const CompareAllButton = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 600;
  line-height: ${() => `${viewSizeCalculator(0.9831)}`}; // 0.8125rem
  letter-spacing: 0%;
  color: #333333;
`;
